<template>
  <section
    class="w-full relative"
  >
    <div
      class="flex flex-col w-full lg:flex-row lg:px-7 z-0"
      :class="{ 'bg-gray': !white}"
    >
      <div
        v-if="resultTitle"
        class="text-[#a4a4a4] w-full  lg:w-1/4 text-center lg:text-left flex-grow py-4 order-1 lg:order-none"
      >
        <h2 class="inline text-lg whitespace-nowrap">
          {{ resultTitle }}: {{ !items.total ? items.data.length : (items.total !== 0 ? items.total : "Nincs találat") }}
        </h2>
      </div>
      <div
        class="flex-grow-[2] w-full lg:w-2/4 order-3 lg:order-none border-t border-white border-solid lg:border-0"
      >
        <div 
          v-if="links && links.length"
          class="text-center flex place-items-center place-content-center font-source-serif-pro"
        >
          <div
            v-for="(link, index) in links"
            :key="index"
            :class="{ 'bg-red': link.url && link.url == $route.path}"
            class="text-xl text-white font-semibold cursor-pointer max-w-max flex place-items-center place-content-center hover:bg-red px-[25px] py-[15px]"
          >
            <a
              v-if="link.callback"
              class="w-auto"
              @click="link.callback()"
            >
              {{ link.name }}
            </a>
            <a
              v-else-if="link.outter"
              class="w-auto"
              target="_blank"
              :href="link.url"
            >
              {{ link.name }}
            </a>
            <nuxt-link
              v-else
              class="w-auto"
              :to="link.url"
            >
              {{ link.name }}
            </nuxt-link>
          </div>
        </div>
      </div>
      <div
        class="flex-grow flex flex-row text-lg place-items-center text-[#a4a4a4] gap-3 justify-around  order-2 lg:order-none w-full  lg:w-1/4"
      >
        <div
          v-if="!hidePageSelector"
          class="cursor-pointer w-2/5 lg:w-1/3"
          :class="{ 'hover:text-white': !white, 'hover:text-gray': white}"
        >
          <div
            v-if="items.prev_page_url"
            class="flex flex-row place-items-center place-content-center gap-3 "
            @click="previousPage()"
          >
            <img
              src="/img/icons/inputs/golden_arrow_icon.svg"
              class="h-[10px] w-[5px] transform rotate-180" 
            >
            <div>
              Előző
            </div>
          </div>
        </div>
        <div
          v-if="!hidePageSelector"
          class="relative flex justify-center text-left mx-2 py-2 w-1/5 lg:w-1/3"
          @mouseover="isMenuOpen = true"
          @mouseleave="isMenuOpen = false"
        >
          <div>
            <button
              v-if="items.last_page && items.last_page !== 1"
              id="options-menu"
              type="button"
              class="inline-flex w-[60px] h-[35px] bg-semigray rounded-md items-center justify-between px-4 py-4 text-sm leading-5 font-medium text-white"
              aria-haspopup="true"
              aria-expanded="true"
              @click="isMenuOpen = !isMenuOpen"
              @mouseover="isMenuOpen = true"
              @mouseleave="isMenuOpen = false"
            >
              {{ items.current_page }}
              <img
                src="/img/menu_lenyilo.svg"
                class="ml-2 transition ease-in-out duration-150"
                width="12"
                :class="{'transform rotate-180':isMenuOpen}"
              >
            </button>
          </div>
          <transition
            v-if="items.last_page"
            enter-active-class="transition ease-out duration-100"
            enter-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
          >
            <div
              v-if="isMenuOpen"
              class="origin-top-right mt-1 absolute top-full w-[60px] rounded-md bg-semigray text-sm max-h-[150px] overflow-auto z-10"
            >
              <div
                class="text-gray-light shadow-xs"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="options-menu"
              >
                <span
                  v-for="index in items.last_page"
                  :key="index" 
                  class="flex items-center py-1 px-4  hover:text-white hover:underline hover:bg-gray cursor-pointer"
                  @click="goToPage(index)"
                >
                  {{ index }}
                </span>
              </div>
            </div>
          </transition>
        </div>
        <div
          v-if="!hidePageSelector"
          class="cursor-pointer w-2/5 lg:w-1/3"
          :class="{ 'hover:text-white': !white, 'hover:text-gray': white}"
        >
          <div
            v-if="items.next_page_url"
            class="flex flex-row place-items-center place-content-center gap-3 "
            @click="nextPage()"
          >
            <div>
              Következő
            </div>
            <img
              src="/img/icons/inputs/golden_arrow_icon.svg"
              class="h-[10px] w-[5px] " 
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    items: {
      type: Object,
      required: true
    },
    resultTitle: {
      type: String,
      default: ''
    },
    white: {
      type: Boolean,
      default: false
    },
    links: {
      type: Array,
      default: () => { return [] }
    },
    hidePageSelector: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isMenuOpen: false,
      pages: []
    };
  },
  watch: {
    items: {
      handler: function(){
        this.calculatePages()
      },
      deep: true
    }
  },
  created() {
    this.calculatePages()
  },
  methods: {
    toTop(){
      window.scrollTo(0,0)
    },
    calculatePages(){
      if(this.items){
        
      for(let i = 1; i <= this.items.last_page; i++){
        this.pages.push({
          value: i,
          text: i,
          key: i
        })
      }
      }
    },
    nextPage() {
      if(this.items){
      const url = decodeURIComponent(this.items.next_page_url);
      // eslint-disable-next-line
      let queryObject = {}

      if (url) {
        url
          .split("?")[1]
          .split("&")
          .forEach(value => {
            const valSplit = value.split("=");
            queryObject[valSplit[0]] = valSplit[1];
          });
      }

      this.$router.push({ query: queryObject });
        
      }
    },
    previousPage() {
      if(this.items){
        const url = decodeURIComponent(this.items.prev_page_url);
        // eslint-disable-next-line
        let queryObject = {}

        if (url) {
          url
            .split("?")[1]
            .split("&")
            .forEach(value => {
              const valSplit = value.split("=");
              queryObject[valSplit[0]] = valSplit[1];
            });
        }

        this.$router.push({ query: queryObject });
      }
    },
    goToPage(index) {
      if(this.items){
      const url = decodeURIComponent(this.items.first_page_url);
      // eslint-disable-next-line
      let queryObject = {}// cloneDeep(this.$store.state.search.queryObject)

      if (url) {
        url
          .split("?")[1]
          .split("&")
          .forEach(value => {
            const valSplit = value.split("=");
            queryObject[valSplit[0]] = valSplit[1];
          });
      }

      queryObject.page = index;

      this.$router.push({ query: queryObject });
      }
    }
  }
};
</script>
